module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABBNAAAQTQFnjAHgAAABUklEQVRYhe2YzU3DQBCFH4h+SAe0QAcJp7lCB+kAOO4pTgd0Ah0ZLRqU4Nl5XpzZlQ95ki/zrDefdnfkn5txHLEm3a6K5gpUodUB3ZlKsERkB2CvqfuU0sA6NJ0yhTlMyk8MqtmWOTBZB/WKanmGNqbyF+rRVFsAicgPSErpGcDR3HBSETgUSLfiU0QGhdrNQBmFAU3OzLYC6stUooCcA8yg8qR9mKCIsXdgznVUoHzvW14ZNvYXATkwLwBy/b4ENafFW+bA5K3IqzBdge3v9DUBIjCDeq8Fr3iILwaqgCl6JsjRv4BYQ+aZIKJqINaQeSZoRlVArCHzTFAEEGvIPBMUAdQbhgKxhswzQRFArCHzTFAEEGvIPJMcBaTPIdOwB4wHdK73njA1QBt9ZegCg4rvsge9usBgwcO1KQycFfJeE4bWMGj95bpE178fc1oXEIBvtODYbrASKQEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_edit.png
// module id = 5KQ+
// module chunks = 4